export enum MeterSample {
  CTO1PHA = '1',
  CTO1PHA_3GIA = '2',
  CTO3PHA = '3'
}

export const MeterSampleLabels = {
  [MeterSample.CTO1PHA]: 'Công tơ 1 pha',
  [MeterSample.CTO1PHA_3GIA]: 'Công tơ 1 pha 3 giá',
  [MeterSample.CTO3PHA]: 'Công tơ 3 pha'
}

export const MeterSampleSelect = [
  {id: MeterSample.CTO1PHA, itemName: MeterSampleLabels[MeterSample.CTO1PHA]},
  {id: MeterSample.CTO1PHA_3GIA, itemName: MeterSampleLabels[MeterSample.CTO1PHA_3GIA]},
  {id: MeterSample.CTO3PHA, itemName: MeterSampleLabels[MeterSample.CTO3PHA]}
];
